"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PreliminarySanitizer =
/*#__PURE__*/
function () {
  function PreliminarySanitizer() {
    _classCallCheck(this, PreliminarySanitizer);
  }

  _createClass(PreliminarySanitizer, null, [{
    key: "preliminarySanitize",
    value: function preliminarySanitize(text) {
      return PreliminarySanitizer.stripHtmlComments(text);
    }
  }, {
    key: "stripHtmlComments",
    value: function stripHtmlComments(text) {
      return text.replace(/<!--([\s\S]+?)(-->|$)/g, "(html comment removed: $1)");
    }
  }]);

  return PreliminarySanitizer;
}();

exports.PreliminarySanitizer = PreliminarySanitizer;